import { render, staticRenderFns } from "./AwardTypeCreate.vue?vue&type=template&id=425a29d9&scoped=true"
import script from "./AwardTypeCreate.vue?vue&type=script&lang=js"
export * from "./AwardTypeCreate.vue?vue&type=script&lang=js"
import style0 from "./AwardTypeCreate.vue?vue&type=style&index=0&id=425a29d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a29d9",
  null
  
)

export default component.exports